module.exports = __webpack_public_path__ + "img/public/SiteIcons/makeIcon.svg?39be0bbb";